const API_PATH = "/auto/auto-businesses";
const AUTO_BUSINESS_ID = "~"; // will always be this for now

enum Env {
  Prod = "prod",
  QA = "qa",
  Dev = "dev",
  Local = "local",
}

const HOSTNAMES: Record<Env, string> = {
  [Env.Prod]: "dealernavigator.com",
  [Env.QA]: "qa.dealernavigator.com",
  [Env.Dev]: "featureddealer-mfe-dev.clouddqt.capitalone.com",
  [Env.Local]: "localhost",
};

const API_HOSTS: Partial<Record<Env, string>> = {
  [Env.Dev]: "https://featureddealer-ms-dev.clouddqt.capitalone.com",
};

function getEnv(): Env {
  return (
    (Object.entries(HOSTNAMES).find(
      ([, h]) => h === location.hostname,
    )?.[0] as Env) ?? Env.Local
  );
}

function getApiBase(): string {
  const apiHost = API_HOSTS[getEnv()];
  return apiHost ? `${apiHost}${API_PATH}` : API_PATH;
}

// dealerId is a host-supplied identifier that is interpolated into the request
// URL path. Allowlist-validate it (reject anything outside [A-Za-z0-9_-]) so
// path separators and other URL metacharacters cannot escape the path segment
// (VULN-006, CWE-20), then encode it as defense-in-depth.
const DEALER_ID_ALLOWLIST = /^[A-Za-z0-9_-]+$/;

export function apiUrl(dealerId: string, apiName: string): string {
  if (!DEALER_ID_ALLOWLIST.test(dealerId)) {
    throw new Error("Invalid dealerId");
  }
  const safeDealerId = encodeURIComponent(dealerId);
  return `${getApiBase()}/${AUTO_BUSINESS_ID}/locations/${safeDealerId}/featured-dealer/${apiName}`;
}

// TODO - this may need to be adjusted based on the environment during integration with QA & PROD
export function apiHeaders(): HeadersInit {
  return {
    Accept: "application/json;v=1.0",
    "Content-Type": "application/json",
  };
}
